import { useEffect, useState } from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import { adminApi } from '@/lib/api';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Save } from 'lucide-react';
import { toast } from 'sonner';

const FIELDS = [
    { key: 'company_name', label: 'Nombre comercial', kind: 'text' },
    { key: 'phone', label: 'Teléfono / WhatsApp (visible)', kind: 'text' },
    { key: 'phone_raw', label: 'Teléfono limpio (wa.me)', kind: 'text' },
    { key: 'phone_secondary', label: 'Teléfono secundario (visible)', kind: 'text' },
    { key: 'phone_secondary_raw', label: 'Teléfono secundario limpio', kind: 'text' },
    { key: 'whatsapp_url', label: 'URL completa de WhatsApp', kind: 'text' },
    { key: 'email', label: 'Email', kind: 'text' },
    { key: 'address', label: 'Dirección', kind: 'text' },
    { key: 'maps_short_url', label: 'Enlace corto de Google Maps', kind: 'text' },
    { key: 'hours', label: 'Horarios (texto)', kind: 'text' },
    { key: 'instagram_handle', label: 'Instagram handle', kind: 'text' },
    { key: 'instagram_url', label: 'Instagram URL', kind: 'text' },
    { key: 'tiktok_handle', label: 'TikTok handle', kind: 'text' },
    { key: 'tiktok_url', label: 'TikTok URL', kind: 'text' },
    { key: 'facebook_handle', label: 'Facebook handle', kind: 'text' },
    { key: 'facebook_url', label: 'Facebook URL', kind: 'text' },
    { key: 'maps_query', label: 'Consulta de mapa', kind: 'text' },
    { key: 'feature_show_gallery', label: 'Mostrar galería en home', kind: 'bool' },
    { key: 'feature_show_social', label: 'Mostrar muro social en home', kind: 'bool' },
    { key: 'feature_show_safety', label: 'Mostrar sección de seguridad', kind: 'bool' },
];

export default function AdminSettingsPage() {
    const [values, setValues] = useState({});
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(null);
    useEffect(() => { adminApi.settings.list().then((items) => { const map = {}; for (const it of items) map[it.key] = it.value; setValues(map); }).finally(() => setLoading(false)); }, []);
    const set = (k, v) => setValues((s) => ({ ...s, [k]: v }));
    const save = async (k) => { setSaving(k); try { await adminApi.settings.upsert(k, values[k]); toast.success('Guardado'); } catch { toast.error('No se pudo guardar'); } finally { setSaving(null); } };
    if (loading) return <AdminLayout title="Configuración"><div className="h-64 bg-white rounded-2xl border border-border animate-pulse" /></AdminLayout>;
    return (
        <AdminLayout title="Configuración">
            <p className="text-sm text-muted-foreground mb-4">Configura la información pública de tu negocio. Si faltan datos, déjalos como pendientes.</p>
            <div className="grid gap-4 md:grid-cols-2">
                {FIELDS.map((f) => (
                    <div key={f.key} className="rounded-2xl bg-white border border-border p-4 shadow-[var(--shadow-soft)]">
                        <Label>{f.label}</Label>
                        {f.kind === 'bool' ? (
                            <div className="mt-2 flex items-center gap-3"><Switch checked={!!values[f.key]} onCheckedChange={(v) => set(f.key, v)} data-testid={`settings-${f.key}`} /> <span className="text-sm text-muted-foreground">{values[f.key] ? 'Activado' : 'Desactivado'}</span></div>
                        ) : (
                            <Input value={values[f.key] ?? ''} onChange={(e) => set(f.key, e.target.value)} className="mt-2" data-testid={`settings-${f.key}`} />
                        )}
                        <button onClick={() => save(f.key)} disabled={saving === f.key} className="mt-3 inline-flex items-center gap-2 rounded-lg bg-primary text-primary-foreground px-3 py-1.5 text-sm disabled:opacity-60" data-testid={`settings-save-${f.key}`}><Save className="size-4" /> {saving === f.key ? 'Guardando…' : 'Guardar'}</button>
                    </div>
                ))}
            </div>
        </AdminLayout>
    );
}
